"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var main_1 = require("../../../main");
var Header_1 = __importDefault(require("../Header"));
/**
 * The Header has a child Search component that is optional and is often used to allow the a user to search for content anywhere on the application.
 */
var Search = /** @class */ (function (_super) {
    __extends(Search, _super);
    function Search(props) {
        var _this = _super.call(this, props) || this;
        _this.openSearch = function () {
            if (_this.state.isOpen === false && (!_this.closeTime || Date.now() - _this.closeTime.getTime() > 300)) {
                _this.setState({ isOpen: true });
                _this.focusSearch();
            }
        };
        _this.onBlur = function () {
            if (_this.state.searchText === '') {
                _this.setState({ isOpen: false });
                _this.closeTime = new Date();
            }
        };
        _this.onType = function (event) {
            clearTimeout(_this.debounceTimer);
            var value = event.target.value;
            _this.setState({ searchText: value });
            _this.debounceTimer = setTimeout(function () { _this.props.onSearch(value); }, _this.props.debounceTimer);
        };
        _this.state = {
            isOpen: false,
            searchText: ''
        };
        _this.textInputRef = React.createRef();
        return _this;
    }
    Search.prototype.render = function () {
        var _a = this.props, placeholder = _a.placeholder, debounceTimer = _a.debounceTimer, className = _a.className, onSearch = _a.onSearch, rest = __rest(_a, ["placeholder", "debounceTimer", "className", "onSearch"]);
        return (React.createElement(Header_1.default.Item, __assign({}, rest, { className: 'search-item' + (this.state.isOpen ? ' open' : '') + ' ' + (this.props.className || ''), onClick: this.openSearch }),
            React.createElement(main_1.Icon, { name: "search", className: "expandable-icon" }),
            React.createElement("div", { className: "ui left icon input" },
                React.createElement("input", { className: "ui input expandable-input", placeholder: this.props.placeholder, ref: this.textInputRef, onChange: this.onType, onBlur: this.onBlur, value: this.state.searchText }))));
    };
    Search.prototype.componentWillUnmount = function () {
        clearTimeout(this.debounceTimer);
    };
    Search.prototype.focusSearch = function () {
        this.textInputRef.current.focus();
    };
    Search.defaultProps = {
        placeholder: 'Search',
        debounceTimer: 300
    };
    return Search;
}(react_1.Component));
exports.default = Search;
